<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<div class="setup-page p-fluid">

  <section class="setup-hero">
    <div class="setup-title">
      <div class="setup-eyebrow">Operations Setup</div>
      <h1>{{ title }}</h1>
      <p>{{ headerSubtitle }}</p>
    </div>
    <div class="setup-actions">
      <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" (click)="loadRows()"></p-button>
      <p-button [label]="'New ' + singularTitle" icon="pi pi-plus" [routerLink]="listRoute + '/add'"></p-button>
    </div>
  </section>

  <section class="setup-metrics" aria-label="Setup summary">
    <div class="metric-tile">
      <span class="metric-label">Total {{ title | lowercase }}</span>
      <strong>{{ rows.length }}</strong>
    </div>
    <div class="metric-tile">
      <span class="metric-label">Active</span>
      <strong>{{ activeCount }}</strong>
    </div>
    <div class="metric-tile">
      <span class="metric-label">Inactive</span>
      <strong>{{ inactiveCount }}</strong>
    </div>
    <div class="metric-tile">
      <span class="metric-label">{{ showLocationColumn ? 'Linked locations' : (showRelationshipColumn ? 'Linked relationships' : 'Current result') }}</span>
      <strong>{{ showLocationColumn ? linkedLocationCount : (showRelationshipColumn ? relatedCount : filteredRows.length) }}</strong>
    </div>
  </section>

  <section class="setup-search card">
    <div class="section-header">
      <div>
        <h2>Search {{ title }}</h2>
        <p>{{ activeSearchCount }} active filters</p>
      </div>
      <div class="section-actions">
        <p-button label="Clear" icon="pi pi-filter-slash" severity="secondary" [outlined]="true" (click)="clearSearch()"></p-button>
        <p-button label="Search" icon="pi pi-search" (click)="applySearch()"></p-button>
      </div>
    </div>

    <form [formGroup]="searchForm" class="search-grid" (ngSubmit)="applySearch()">
      <div class="field" *ngIf="type !== 'WAREHOUSE'; else warehouseSearch">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="setupNameSearch" pInputText formControlName="name">
            <label for="setupNameSearch">Name</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <ng-template #warehouseSearch>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-warehouse"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="setupWarehouseSearch" [options]="rows" optionLabel="name" optionValue="id" formControlName="warehouseId" [filter]="true" filterBy="name,code" [showClear]="true" styleClass="w-full"></p-select>
              <label for="setupWarehouseSearch">Warehouse</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
      </ng-template>
      <div class="field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input id="setupCodeSearch" pInputText formControlName="code">
            <label for="setupCodeSearch">Code</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field" *ngIf="showLocationColumn">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="setupLocationSearch" [options]="locationOptions" optionLabel="label" optionValue="value" formControlName="location" [filter]="true" filterBy="label" [showClear]="true" styleClass="w-full"></p-select>
            <label for="setupLocationSearch">Location</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field" *ngIf="showSupplierColumn">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="setupSupplierSearch" [options]="supplierOptions" optionLabel="label" optionValue="value" formControlName="supplier" [filter]="true" filterBy="label" [showClear]="true" styleClass="w-full"></p-select>
            <label for="setupSupplierSearch">Supplier</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field" *ngIf="showSupplierColumn">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="setupSupplierWarehouseSearch" [options]="supplierWarehouseOptions" optionLabel="label" optionValue="value" formControlName="supplierWarehouse" [filter]="true" filterBy="label" [showClear]="true" styleClass="w-full"></p-select>
            <label for="setupSupplierWarehouseSearch">Supplier Warehouse</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field" *ngIf="showSupplierColumn">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-shield"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="setupOwnershipSearch" [options]="ownershipOptions" optionLabel="label" optionValue="value" formControlName="ownership" [showClear]="true" styleClass="w-full"></p-select>
            <label for="setupOwnershipSearch">Ownership</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field" *ngIf="showRelationshipColumn">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="setupRelationshipSearch" [options]="relationshipOptions" optionLabel="label" optionValue="value" formControlName="relationship" [filter]="true" filterBy="label" [showClear]="true" styleClass="w-full"></p-select>
            <label for="setupRelationshipSearch">{{ relationshipFilterLabel }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <div class="field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-check-circle"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="setupActiveStatus" [options]="activeFilterOptions" optionLabel="label" optionValue="value" formControlName="activeStatus" [showClear]="true" styleClass="w-full"></p-select>
            <label for="setupActiveStatus">Status</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
    </form>
  </section>

  <section class="setup-table card">
    <div class="section-header table-heading">
      <div>
        <h2>{{ title }} Directory</h2>
        <p *ngIf="lastUpdated">Updated {{ lastUpdated | date:'shortTime' }}</p>
      </div>
      <span class="result-chip">{{ filteredRows.length }} of {{ rows.length }} records</span>
    </div>

    <p-table [value]="filteredRows" [paginator]="true" [rows]="pageSize" [(first)]="first"
      [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[20, 50, 100]" dataKey="id" styleClass="p-datatable-sm p-datatable-gridlines setup-data-table"
      [tableStyle]="{ 'min-width': tableMinWidth() }">
      <ng-template pTemplate="header">
        <tr>
          @if (type === 'WAREHOUSE') {
            <th>Warehouse</th>
            <th>Location &amp; Region</th>
            <th>Ownership &amp; Supplier</th>
          } @else {
            <th>Name</th>
            <th>Code</th>
          }
          <th *ngIf="type === 'REGION'">Default Warehouse</th>
          <th *ngIf="showRelationshipColumn && type !== 'WAREHOUSE'">Relationship</th>
          <th>Status</th>
          <th>Audit</th>
          <th class="text-center">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          @if (type === 'WAREHOUSE') {
            <td class="name-cell">
              <div class="tree-name"><i class="pi pi-warehouse"></i><div class="tree-name-copy"><strong>{{ row.name || '-' }}</strong><span class="code-pill">{{ rowCode(row) }}</span></div></div>
            </td>
            <td><div class="warehouse-cell"><strong>{{ relationshipLabel(row) }}</strong><span>{{ locationLabel(row) }}</span></div></td>
            <td><div class="warehouse-cell"><strong>{{ ownershipLabel(row) }}</strong><span *ngIf="row.supplierClientName">Supplier: {{ row.supplierClientName }}</span><span *ngIf="row.supplierWarehouseName">Warehouse: {{ row.supplierWarehouseName }}</span></div></td>
          } @else {
            <td class="name-cell">
              <div class="tree-name" [style.padding-left.rem]="rowDepth(row) * 1.5">
                <i class="pi" [class.pi-folder]="rowDepth(row) === 0" [class.pi-folder-open]="rowDepth(row) > 0"></i>
                <div class="tree-name-copy">
                  <strong>{{ row.name || '-' }}</strong>
                <span *ngIf="type === 'CATEGORY'">{{ rowTypeLabel(row) }}<ng-container *ngIf="row.childCount"> · {{ row.childCount }} child categories</ng-container></span>
                </div>
              </div>
            </td>
            <td><span class="code-pill">{{ rowCode(row) }}</span></td>
          }
          <td *ngIf="type === 'REGION'">
            <div class="tree-name-copy">
              <strong>{{ defaultWarehouseLabel(row) }}</strong>
              <span *ngIf="row.defaultWarehouseId">Regional cross-dock hub</span>
            </div>
          </td>
          <td *ngIf="showRelationshipColumn && type !== 'WAREHOUSE'">{{ relationshipLabel(row) }}</td>
          <td><p-tag [value]="rowStatus(row)" [severity]="statusSeverity(rowStatus(row))"></p-tag></td>
          <td><app-audit-directory-cell [stamp]="row"></app-audit-directory-cell></td>
          <td class="text-center">
            <div class="row-actions">
              <p-button *ngIf="type === 'CATEGORY'" icon="pi pi-plus" [text]="true" severity="success" [routerLink]="listRoute + '/add'" [queryParams]="addChildQuery(row)" pTooltip="Add child category"></p-button>
              <p-button icon="pi pi-eye" [text]="true" [routerLink]="rowViewRoute(row)" [queryParams]="rowActionQuery(row)" pTooltip="View"></p-button>
              <p-button icon="pi pi-pencil" [text]="true" severity="info" [routerLink]="rowEditRoute(row)" [queryParams]="rowActionQuery(row)" pTooltip="Edit"></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="emptyColspan()">
            <div class="empty-state">
              <i class="pi pi-search"></i>
              <strong>No {{ title | lowercase }} found</strong>
              <span>No matching setup records.</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>
</div>
